import {type EventStep, validSteps} from '~/CreateFabricInvitation/components/NavHeader/types';
import {INIT_UNLOCK_STATE, UNLOCK_STEPS} from '~/common/fabric/constants';

export type UnlockedStepsState = string[];
export type UnlockedStepsAction =
  | {
      type: typeof INIT_UNLOCK_STATE;
      payload: {
        inEditMode: boolean;
        activeStep: string;
        rawSteps: string[];
      };
    }
  | {
      type: typeof UNLOCK_STEPS;
      payload: string[];
    }
  | {
      type: string;
      payload?: unknown;
    };

export const createInitialState = ({
  inEditMode,
  activeStep,
  rawSteps,
}: {
  inEditMode: boolean;
  activeStep: string;
  rawSteps: Record<string, EventStep>;
}): string[] => {
  const allStepsArr: string[] = [...validSteps];

  // If not in edit mode, filter steps up to activeStep (if present)
  const stepArr: string[] = rawSteps
    ? Object.values(rawSteps)
        .filter(
          (step) =>
            step.id > 0 &&
            (!activeStep || (rawSteps[activeStep] && step.id <= rawSteps[activeStep].id))
        )
        .map((step) => step.name)
    : [];

  return inEditMode ? allStepsArr : stepArr;
};

export const unlockedStepsReducer = (
  state: UnlockedStepsState = ['customize'],
  action: UnlockedStepsAction = {type: ''}
): UnlockedStepsState => {
  switch (action.type) {
    case INIT_UNLOCK_STATE: {
      if (
        action.payload &&
        typeof action.payload === 'object' &&
        'inEditMode' in action.payload &&
        'activeStep' in action.payload &&
        'rawSteps' in action.payload
      ) {
        const {inEditMode, activeStep, rawSteps} = action.payload as {
          inEditMode: boolean;
          activeStep: string;
          rawSteps: Record<string, EventStep>;
        };
        const newSteps = createInitialState({inEditMode, activeStep, rawSteps});
        return Array.from(new Set([...state, ...newSteps]));
      }
      return state;
    }
    case UNLOCK_STEPS: {
      const newSteps = Array.isArray(action.payload) ? action.payload : [];
      return Array.from(new Set([...state, ...newSteps]));
    }
    default:
      return state;
  }
};
